import { setLocale } from 'yup';

setLocale({
  mixed: {
    required: 'Whoops, looks like you missed this here.'
  }
});
